import useSWR from 'swr';
import { getTeamByUUID } from '@/repositories/teams';

export function useTeamData(team_uuid: string) {
  const { data, isLoading, error, mutate, isValidating } = useSWR(['team', team_uuid], () => getTeamByUUID(team_uuid), {
    dedupingInterval: 10000, // 同じキーでの重複リクエストを防ぐ間隔（10秒）
    revalidateOnFocus: true,
    revalidateOnReconnect: false,
    keepPreviousData: true,
    shouldRetryOnError: false
  });

  return {
    data,
    isLoading,
    error,
    mutate,
    isValidating
  };
}
